import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { C, font, SHOW_FEATURES_MENU } from "../tokens";
import logoImg from "../assets/site/logo.png";
import { features, featureCategories } from "../data/features";

// ─── Logo (hp) ─────────────────────────────────────────────
function Logo({ size = 36, light = false, to = "/" }) {
  return (
    <Link
      to={to}
      aria-label="IMOBMEET — página inicial"
      onClick={() => {
        try {
          window.scrollTo({ top: 0, behavior: "auto" });
        } catch {}
      }}
      style={{
        display: "inline-flex",
        alignItems: "center",
        textDecoration: "none",
        height: size,
        filter: light ? "brightness(0) invert(1)" : "none",
        transition: "opacity 0.2s",
      }}
      onMouseEnter={(o) => (o.currentTarget.style.opacity = "0.85")}
      onMouseLeave={(o) => (o.currentTarget.style.opacity = "1")}
    >
      <img
        src={logoImg}
        alt="imobmeet"
        style={{ height: size, width: "auto", display: "block" }}
      />
    </Link>
  );
}

// ─── CTA (se) ──────────────────────────────────────────────
function Cta({ children, to, style = {} }) {
  return (
    <Link
      to={to}
      className="cta-primary"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "13px 22px",
        borderRadius: 11,
        fontSize: 14,
        fontWeight: 700,
        textDecoration: "none",
        fontFamily: font,
        cursor: "pointer",
        background: C.accent,
        color: "white",
        border: "1.5px solid transparent",
        boxShadow:
          "0 8px 24px rgba(5,96,255,0.28), inset 0 1px 0 rgba(255,255,255,0.18)",
        ...style,
      }}
    >
      <span
        style={{
          position: "relative",
          zIndex: 1,
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        {children} <span className="arrow">→</span>
      </span>
    </Link>
  );
}

// ─── Ícone wrapper (cn) ────────────────────────────────────
const cn = (e) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {e}
  </svg>
);

// ─── Soluções mega-menu (il) ───────────────────────────────
const il = [
  {
    label: "CRM para Incorporadoras",
    to: "/crm-incorporadoras",
    desc: "Gestão completa de empreendimentos verticais — torres, andares e tipologias.",
    bg: "linear-gradient(135deg, #0560FF 0%, #204493 100%)",
    color: "#0560FF",
    icon: cn(
      <>
        <rect x="5" y="3" width="14" height="18" rx="1.5" />
        <path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01" />
        <path d="M10 21v-3h4v3" />
      </>
    ),
  },
  {
    label: "CRM para Construtoras",
    to: "/crm-construtoras",
    desc: "Funil completo, da obra à venda, em uma única plataforma.",
    bg: "linear-gradient(135deg, #F59E0B 0%, #0D9488 100%)",
    color: "#F59E0B",
    icon: cn(
      <>
        <rect x="5" y="3" width="14" height="18" rx="1.5" />
        <path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01" />
        <path d="M10 21v-3h4v3" />
      </>
    ),
  },
  {
    label: "CRM para Loteadoras",
    to: "/crm-loteadoras",
    desc: "Do primeiro lead ao contrato em loteamentos com mapa humanizado.",
    bg: "linear-gradient(135deg, #10B981 0%, #047857 100%)",
    color: "#10B981",
    icon: cn(
      <>
        <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2z" />
        <path d="M9 4v14M15 6v14" />
      </>
    ),
  },
  {
    label: "Sistema para Loteamento",
    to: "/sistema-para-loteamento",
    desc: "Software de gestão de loteamento: lotes, recebíveis e contratos.",
    bg: "linear-gradient(135deg, #059669 0%, #10B981 100%)",
    color: "#059669",
    icon: cn(
      <>
        <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2z" />
        <path d="M9 4v14M15 6v14" />
      </>
    ),
  },
  {
    label: "Gestão de Recebíveis",
    to: "/gestao-de-recebiveis",
    desc: "Boletos, régua de cobrança no WhatsApp e fluxo de caixa previsível.",
    bg: "linear-gradient(135deg, #F59E0B 0%, #B45309 100%)",
    color: "#F59E0B",
    icon: cn(
      <>
        <path d="M4 2v20l2.5-1.5L9 22l3-1.5L15 22l2.5-1.5L20 22V2l-2.5 1.5L15 2l-3 1.5L9 2 6.5 3.5 4 2z" />
        <path d="M8 8h8M8 12h8M8 16h5" />
      </>
    ),
  },
  {
    label: "Pagadoria inteligente",
    to: "/split-comissoes",
    desc: "Particionamento automático da comissão por venda, com repasse via split.",
    bg: "linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)",
    color: "#8B5CF6",
    icon: cn(
      <>
        <circle cx="6" cy="6" r="3" />
        <circle cx="6" cy="18" r="3" />
        <circle cx="18" cy="12" r="3" />
        <path d="M9 6h3a3 3 0 0 1 3 3v0M9 18h3a3 3 0 0 0 3-3v0" />
      </>
    ),
  },
  {
    label: "Imobmeet Autovendas",
    to: "/autovendas",
    desc: "Venda 24h com seleção de unidade e pagamento via PIX ou cartão.",
    bg: "linear-gradient(135deg, #EC4899 0%, #BE185D 100%)",
    color: "#EC4899",
    icon: cn(<path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />),
  },
  {
    label: "HUB Whatsapp",
    to: "/funcionalidades/hub-whatsapp",
    desc: "Atendimento e disparos no WhatsApp multi-corretor, centralizados e com IA.",
    bg: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
    color: "#25D366",
    icon: cn(
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    ),
  },
];

// ─── Mega card (d0) ────────────────────────────────────────
function MegaCard({ s: e, onClick: t }) {
  const r = useRef(null);
  const o = (a) => {
    const l = r.current;
    if (!l) return;
    const d = l.getBoundingClientRect();
    const c = ((a.clientX - d.left) / d.width) * 100;
    const u = ((a.clientY - d.top) / d.height) * 100;
    l.style.setProperty("--mx", `${c}%`);
    l.style.setProperty("--my", `${u}%`);
    const m = ((a.clientY - d.top) / d.height - 0.5) * -6;
    const g = ((a.clientX - d.left) / d.width - 0.5) * 8;
    l.style.setProperty("--rx", `${m}deg`);
    l.style.setProperty("--ry", `${g}deg`);
  };
  const i = () => {
    const a = r.current;
    if (a) {
      a.style.setProperty("--rx", "0deg");
      a.style.setProperty("--ry", "0deg");
    }
  };
  return (
    <Link
      ref={r}
      to={e.to || "#"}
      onClick={t}
      onMouseMove={o}
      onMouseLeave={i}
      className="mega-card"
      style={{
        "--sol": e.color,
        display: "flex",
        flexDirection: "column",
        padding: "15px 16px",
        borderRadius: 15,
        background: e.active ? `${e.color}0F` : C.surface,
        color: C.text,
        textDecoration: "none",
        position: "relative",
        overflow: "hidden",
        border: `1.5px solid ${e.active ? e.color : C.border}`,
      }}
    >
      <div
        className="mega-spotlight"
        style={{
          position: "absolute",
          inset: 0,
          background: `radial-gradient(circle 240px at var(--mx, 50%) var(--my, 50%), ${e.color}1F, transparent 60%)`,
          opacity: 0,
          transition: "opacity 0.35s cubic-bezier(.16,1,.3,1)",
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <span
          className="mega-icon"
          style={{
            width: 38,
            height: 38,
            borderRadius: 11,
            flexShrink: 0,
            background: e.bg,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: `0 10px 22px ${e.color}3D`,
            transition: "transform 0.4s cubic-bezier(.16,1,.3,1)",
          }}
        >
          {e.icon}
        </span>
        {e.active && (
          <span
            style={{
              fontFamily: font,
              fontSize: 9.5,
              fontWeight: 800,
              letterSpacing: 0.6,
              textTransform: "uppercase",
              color: e.color,
              background: `${e.color}1A`,
              border: `1px solid ${e.color}55`,
              padding: "4px 9px",
              borderRadius: 999,
            }}
          >
            Você está aqui
          </span>
        )}
      </div>
      <div style={{ position: "relative", zIndex: 1 }}>
        <h4
          className="mega-title"
          style={{
            fontFamily: font,
            fontSize: 15,
            fontWeight: 800,
            margin: "0 0 4px",
            letterSpacing: -0.3,
            lineHeight: 1.15,
            color: C.text,
            transition: "transform 0.35s cubic-bezier(.16,1,.3,1)",
          }}
        >
          {e.label}
        </h4>
        <p
          className="mega-desc"
          style={{
            fontFamily: font,
            fontSize: 12.5,
            color: C.muted,
            lineHeight: 1.4,
            margin: 0,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {e.desc}
        </p>
      </div>
    </Link>
  );
}

// ─── Rótulo de seção no drawer mobile (aa) ─────────────────
function MobileLabel({ label }) {
  return (
    <div
      style={{
        fontFamily: font,
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: 1,
        textTransform: "uppercase",
        color: C.muted,
        padding: "16px 8px 8px",
      }}
    >
      {label}
    </div>
  );
}

// ─── Header (_n) ───────────────────────────────────────────
export default function Navbar({ activeSolution }) {
  const [scrolled, setScrolled] = useState(false);
  const [solOpen, setSolOpen] = useState(false);
  const [segOpen, setSegOpen] = useState(false);
  const [funcOpen, setFuncOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const solTimer = useRef(null);
  const segTimer = useRef(null);
  const funcTimer = useRef(null);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", h, { passive: true });
    h();
    return () => window.removeEventListener("scroll", h);
  }, []);

  const openSol = () => {
    clearTimeout(solTimer.current);
    setSolOpen(true);
  };
  const closeSol = () => {
    solTimer.current = setTimeout(() => setSolOpen(false), 140);
  };
  const openSeg = () => {
    clearTimeout(segTimer.current);
    setSegOpen(true);
  };
  const closeSeg = () => {
    segTimer.current = setTimeout(() => setSegOpen(false), 140);
  };
  const openFunc = () => {
    clearTimeout(funcTimer.current);
    setFuncOpen(true);
  };
  const closeFunc = () => {
    funcTimer.current = setTimeout(() => setFuncOpen(false), 140);
  };

  const w = [
    {
      label: "Incorporadoras",
      to: "/crm-incorporadoras",
      tag: "Vertical",
      bg: "linear-gradient(135deg, #0560FF 0%, #204493 100%)",
      color: "#0560FF",
      desc: "CRM para empreendimentos verticais — torres, andares e tipologias.",
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="5" y="3" width="14" height="18" rx="1.5" />
          <path d="M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01" />
          <path d="M10 21v-3h4v3" />
        </svg>
      ),
    },
    {
      label: "Loteadoras",
      to: "/crm-loteadoras",
      tag: "Horizontal",
      bg: "linear-gradient(135deg, #10B981 0%, #047857 100%)",
      color: "#10B981",
      desc: "CRM para loteamentos com mapa de lotes em tempo real.",
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2z" />
          <path d="M9 4v14M15 6v14" />
        </svg>
      ),
    },
  ];

  const E = [
    { label: "Integrações", to: "/integracoes" },
    { label: "Conteúdo", to: "/conteudo" },
  ];

  const f = il.map((h) => ({ ...h, active: h.to === activeSolution }));

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: "rgba(255,255,255,0.96)",
        borderBottom: `1px solid ${scrolled ? C.border : "transparent"}`,
        backdropFilter: "saturate(160%) blur(14px)",
        WebkitBackdropFilter: "saturate(160%) blur(14px)",
        transition: "border-color 0.3s, box-shadow 0.3s",
        boxShadow: scrolled ? "0 4px 16px rgba(10,15,30,0.04)" : "none",
      }}
    >
      <div
        style={{
          maxWidth: 1336,
          margin: "0 auto",
          padding: "0 28px",
          display: "flex",
          alignItems: "center",
          height: 72,
          gap: 36,
        }}
      >
        <Logo />
        <div
          className="nav-desktop"
          style={{
            display: "flex",
            gap: 4,
            flex: 1,
            alignItems: "center",
            marginLeft: 24,
          }}
        >
          <button
            className="nav-link"
            onMouseEnter={openSol}
            onMouseLeave={closeSol}
            style={{
              background: "none",
              border: "none",
              padding: "8px 0",
              fontSize: 15.5,
              color: solOpen ? C.accent : C.text,
              fontWeight: 600,
              fontFamily: font,
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            Soluções
          </button>
          {SHOW_FEATURES_MENU && (
            <button
              className="nav-link"
              onMouseEnter={openFunc}
              onMouseLeave={closeFunc}
              style={{
                background: "none",
                border: "none",
                padding: "8px 0",
                marginLeft: 28,
                fontSize: 15.5,
                color: funcOpen ? C.accent : C.text,
                fontWeight: 600,
                fontFamily: font,
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              Funcionalidades
            </button>
          )}
          <div
            style={{ position: "relative" }}
            onMouseEnter={openSeg}
            onMouseLeave={closeSeg}
          >
            <button
              className="nav-link"
              style={{
                background: "none",
                border: "none",
                padding: "8px 0",
                marginLeft: 28,
                fontSize: 15.5,
                color: segOpen ? C.accent : C.text,
                fontWeight: 600,
                fontFamily: font,
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              Segmentos
            </button>
            {segOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 28,
                  marginTop: 10,
                  width: 420,
                  background: C.surface,
                  border: `1px solid ${C.border}`,
                  borderRadius: 20,
                  boxShadow: "0 30px 70px rgba(10,15,30,0.20)",
                  padding: 12,
                  zIndex: 101,
                  overflow: "hidden",
                  animation: "slide-down-fade 0.2s cubic-bezier(.16,1,.3,1) both",
                }}
              >
                <div
                  style={{
                    fontFamily: font,
                    fontSize: 10.5,
                    fontWeight: 800,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                    color: C.muted,
                    padding: "6px 12px 10px",
                  }}
                >
                  Escolha o seu segmento
                </div>
                {w.map((h) => (
                  <Link
                    key={h.to}
                    to={h.to}
                    onClick={() => setSegOpen(false)}
                    className="seg-card"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 14,
                      padding: "14px 14px",
                      borderRadius: 14,
                      textDecoration: "none",
                      border: "1px solid transparent",
                      transition: "background 0.18s, border-color 0.18s",
                    }}
                    onMouseEnter={(x) => {
                      x.currentTarget.style.background = `${h.color}12`;
                      x.currentTarget.style.borderColor = `${h.color}55`;
                    }}
                    onMouseLeave={(x) => {
                      x.currentTarget.style.background = "transparent";
                      x.currentTarget.style.borderColor = "transparent";
                    }}
                  >
                    <span
                      style={{
                        width: 46,
                        height: 46,
                        borderRadius: 13,
                        flexShrink: 0,
                        background: h.bg,
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: `0 8px 18px ${h.color}45`,
                      }}
                    >
                      {h.icon}
                    </span>
                    <span style={{ flex: 1, minWidth: 0 }}>
                      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span
                          style={{
                            fontFamily: font,
                            fontSize: 15.5,
                            fontWeight: 800,
                            color: C.text,
                          }}
                        >
                          {h.label}
                        </span>
                        <span
                          style={{
                            fontFamily: font,
                            fontSize: 9.5,
                            fontWeight: 800,
                            letterSpacing: 0.4,
                            textTransform: "uppercase",
                            color: h.color,
                            background: `${h.color}1A`,
                            border: `1px solid ${h.color}55`,
                            padding: "2px 7px",
                            borderRadius: 999,
                          }}
                        >
                          {h.tag}
                        </span>
                      </span>
                      <span
                        style={{
                          display: "block",
                          fontFamily: font,
                          fontSize: 12.5,
                          color: C.muted,
                          marginTop: 4,
                          lineHeight: 1.45,
                        }}
                      >
                        {h.desc}
                      </span>
                    </span>
                    <span
                      className="seg-arrow"
                      style={{
                        color: h.color,
                        fontSize: 17,
                        marginTop: 12,
                        transition: "transform 0.18s",
                        flexShrink: 0,
                      }}
                    >
                      →
                    </span>
                  </Link>
                ))}
                <div style={{ height: 1, background: C.border, margin: "10px 8px" }} />
                <Link
                  to="/agendar-demo"
                  onClick={() => setSegOpen(false)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 10,
                    padding: "10px 14px",
                    borderRadius: 12,
                    textDecoration: "none",
                  }}
                  onMouseEnter={(h) => (h.currentTarget.style.background = C.bgAlt)}
                  onMouseLeave={(h) => (h.currentTarget.style.background = "transparent")}
                >
                  <span style={{ fontFamily: font, fontSize: 13, color: C.muted }}>
                    Quer saber mais?{" "}
                    <strong style={{ color: C.text, fontWeight: 800 }}>
                      Fale com um especialista
                    </strong>
                  </span>
                  <span style={{ color: C.accent, fontSize: 16 }}>→</span>
                </Link>
              </div>
            )}
          </div>
          {E.map((h) => (
            <Link
              key={h.label}
              to={h.to}
              className="nav-link"
              style={{
                fontSize: 15.5,
                color: C.text,
                textDecoration: "none",
                fontWeight: 600,
                fontFamily: font,
                marginLeft: 28,
              }}
            >
              {h.label}
            </Link>
          ))}
        </div>
        <div
          style={{ display: "flex", gap: 12, alignItems: "center", marginLeft: "auto" }}
        >
          <div className="nav-desktop">
            <Cta to="/agendar-demo" style={{ padding: "10px 20px", fontSize: 13 }}>
              Agendar demonstração
            </Cta>
          </div>
          <button
            className="nav-burger"
            aria-label="Abrir menu"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((h) => !h)}
            style={{
              display: "none",
              width: 44,
              height: 44,
              borderRadius: 12,
              cursor: "pointer",
              alignItems: "center",
              justifyContent: "center",
              background: mobileOpen ? C.bgAlt : "transparent",
              border: `1px solid ${mobileOpen ? C.border : "transparent"}`,
              color: C.text,
            }}
          >
            {mobileOpen ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              >
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              >
                <path d="M3 6h18M3 12h18M3 18h18" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
          style={{
            position: "fixed",
            top: 72,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 80,
            background: "rgba(10,15,30,0.45)",
            animation: "slide-up-fade 0.2s ease both",
          }}
        />
      )}
      {mobileOpen && (
        <div
          className="nav-mobile-panel"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 90,
            background: C.surface,
            borderBottom: `1px solid ${C.border}`,
            borderRadius: "0 0 20px 20px",
            boxShadow: "0 24px 50px rgba(10,15,30,0.22)",
            padding: "10px 18px 22px",
            maxHeight: "calc(100vh - 72px)",
            overflowY: "auto",
            animation: "slide-down-fade 0.22s cubic-bezier(.16,1,.3,1) both",
          }}
        >
          <MobileLabel label="Segmentos" />
          {w.map((h) => (
            <Link
              key={h.to}
              to={h.to}
              onClick={() => setMobileOpen(false)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 13,
                padding: "12px 8px",
                borderRadius: 12,
                textDecoration: "none",
                color: C.text,
              }}
            >
              <span
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 11,
                  flexShrink: 0,
                  background: h.bg,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: `0 6px 14px ${h.color}40`,
                }}
              >
                {h.icon}
              </span>
              <span>
                <span
                  style={{
                    display: "block",
                    fontFamily: font,
                    fontSize: 15.5,
                    fontWeight: 800,
                    color: C.text,
                  }}
                >
                  {h.label}
                </span>
                <span
                  style={{
                    display: "block",
                    fontFamily: font,
                    fontSize: 12.5,
                    color: C.muted,
                    marginTop: 2,
                  }}
                >
                  {h.tag}
                </span>
              </span>
            </Link>
          ))}
          <MobileLabel label="Soluções" />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            {f.map((h, x) => (
              <Link
                key={x}
                to={h.to}
                onClick={() => setMobileOpen(false)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 9,
                  fontFamily: font,
                  fontSize: 13.5,
                  fontWeight: 700,
                  color: C.text,
                  textDecoration: "none",
                  padding: "12px 12px",
                  borderRadius: 11,
                  background: C.bgAlt,
                  border: `1px solid ${C.border}`,
                }}
              >
                <span
                  style={{
                    width: 9,
                    height: 9,
                    borderRadius: "50%",
                    flexShrink: 0,
                    background: h.color || C.accent,
                  }}
                />
                {h.label.replace("CRM para ", "")}
              </Link>
            ))}
          </div>
          <MobileLabel label="Mais" />
          {SHOW_FEATURES_MENU && (
            <Link
              to="/funcionalidades"
              onClick={() => setMobileOpen(false)}
              style={{
                display: "block",
                fontFamily: font,
                fontSize: 15.5,
                fontWeight: 700,
                color: C.text,
                textDecoration: "none",
                padding: "12px 8px",
                borderRadius: 10,
              }}
            >
              Funcionalidades
            </Link>
          )}
          {E.map((h) => (
            <Link
              key={h.label}
              to={h.to}
              onClick={() => setMobileOpen(false)}
              style={{
                display: "block",
                fontFamily: font,
                fontSize: 15.5,
                fontWeight: 700,
                color: C.text,
                textDecoration: "none",
                padding: "12px 8px",
                borderRadius: 10,
              }}
            >
              {h.label}
            </Link>
          ))}
          <Link
            to="/agendar-demo"
            onClick={() => setMobileOpen(false)}
            style={{
              display: "block",
              textAlign: "center",
              marginTop: 16,
              fontFamily: font,
              fontSize: 15.5,
              fontWeight: 700,
              color: "#fff",
              textDecoration: "none",
              background: C.accent,
              padding: "15px",
              borderRadius: 12,
              boxShadow: "0 8px 24px rgba(5,96,255,0.28)",
            }}
          >
            Agendar demonstração
          </Link>
        </div>
      )}

      {solOpen && (
        <div
          onMouseEnter={openSol}
          onMouseLeave={closeSol}
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: C.surface,
            borderTop: `1px solid ${C.border}`,
            borderBottom: `1px solid ${C.border}`,
            boxShadow: "0 24px 60px rgba(10,15,30,0.18)",
            padding: "32px 28px 36px",
            animation: "slide-down-fade 0.25s cubic-bezier(.16,1,.3,1) both",
          }}
        >
          <div style={{ maxWidth: 1280, margin: "0 auto" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
                marginBottom: 22,
              }}
            >
              <div>
                <div
                  style={{
                    fontFamily: font,
                    fontSize: 11,
                    fontWeight: 800,
                    color: C.muted,
                    letterSpacing: 0.6,
                    marginBottom: 4,
                    textTransform: "uppercase",
                  }}
                >
                  Soluções IMOBMEET
                </div>
                <h3
                  style={{
                    fontFamily: font,
                    fontSize: 22,
                    fontWeight: 800,
                    color: C.text,
                    margin: 0,
                    letterSpacing: -0.5,
                  }}
                >
                  Escolha por onde começar
                </h3>
              </div>
            </div>
            <div
              className="mega-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: 12,
              }}
            >
              {f.map((h, x) => (
                <MegaCard key={x} s={h} onClick={() => setSolOpen(false)} />
              ))}
            </div>
          </div>
        </div>
      )}

      {SHOW_FEATURES_MENU && funcOpen && (
        <div
          onMouseEnter={openFunc}
          onMouseLeave={closeFunc}
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: C.surface,
            borderTop: `1px solid ${C.border}`,
            borderBottom: `1px solid ${C.border}`,
            boxShadow: "0 24px 60px rgba(10,15,30,0.18)",
            padding: "28px 28px 30px",
            animation: "slide-down-fade 0.25s cubic-bezier(.16,1,.3,1) both",
          }}
        >
          <div style={{ maxWidth: 1280, margin: "0 auto" }}>
            {(() => {
              const featured = features.find((ft) => ft.isNew && ft.ownPage);
              return (
                <div className="func-mega-grid" style={{ display: "grid", gridTemplateColumns: featured ? "1fr 1fr 1fr 290px" : "repeat(3, 1fr)", gap: 28 }}>
                  {featureCategories.map((cat) => (
                    <div key={cat} role="group" aria-label={cat}>
                      <div style={{ fontFamily: font, fontSize: 11, fontWeight: 800, letterSpacing: 0.8, textTransform: "uppercase", color: C.muted, marginBottom: 12 }}>
                        {cat}
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        {features.filter((ft) => ft.category === cat && ft.slug !== "integracoes").map((ft) => (
                          <Link
                            key={ft.slug}
                            to={ft.ownPage ? `/funcionalidades/${ft.slug}` : ft.externalTo}
                            onClick={() => setFuncOpen(false)}
                            className="func-mega-link"
                            style={{ display: "flex", alignItems: "center", gap: 11, padding: "8px 10px", borderRadius: 11, textDecoration: "none", color: C.text, transition: "background 0.15s", minWidth: 0 }}
                            onMouseEnter={(e) => (e.currentTarget.style.background = C.bgAlt)}
                            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                          >
                            <span style={{ width: 34, height: 34, borderRadius: 9, flexShrink: 0, background: ft.bg, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                              {ft.icon}
                            </span>
                            <span style={{ display: "flex", flexDirection: "column", minWidth: 0, gap: 1 }}>
                              <span style={{ display: "flex", alignItems: "center", gap: 7, fontFamily: font, fontSize: 14, fontWeight: 700, color: C.text, lineHeight: 1.2 }}>
                                {ft.name}
                                {ft.isNew && (
                                  <span style={{ fontFamily: font, fontSize: 9.5, fontWeight: 800, letterSpacing: 0.5, textTransform: "uppercase", color: "#fff", background: "linear-gradient(135deg, #F97316, #C2410C)", padding: "2px 6px", borderRadius: 999 }}>Novo</span>
                                )}
                              </span>
                              {ft.tagline && (
                                <span style={{ fontFamily: font, fontSize: 12, color: C.muted, lineHeight: 1.3, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 300 }}>
                                  {ft.tagline}
                                </span>
                              )}
                            </span>
                          </Link>
                        ))}
                      </div>
                    </div>
                  ))}
                  {featured && (
                    <Link
                      to={`/funcionalidades/${featured.slug}`}
                      onClick={() => setFuncOpen(false)}
                      className="func-mega-link func-mega-featured"
                      style={{ display: "flex", flexDirection: "column", gap: 10, padding: 14, borderRadius: 16, textDecoration: "none", color: C.text, background: C.bgAlt, border: `1px solid ${C.border}` }}
                    >
                      <span style={{ fontFamily: font, fontSize: 10.5, fontWeight: 800, letterSpacing: 0.8, textTransform: "uppercase", color: featured.color }}>Novidade</span>
                      <span style={{ display: "block", borderRadius: 10, overflow: "hidden", border: `1px solid ${C.border}`, background: "#fff", aspectRatio: "16 / 9" }}>
                        <img src={featured.cover} alt={featured.name} style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top", display: "block" }} loading="lazy" decoding="async" />
                      </span>
                      <span style={{ fontFamily: font, fontSize: 15, fontWeight: 800, color: C.text, letterSpacing: -0.2 }}>{featured.name}</span>
                      <span style={{ fontFamily: font, fontSize: 12.5, lineHeight: 1.45, color: C.muted }}>{featured.tagline}</span>
                      <span style={{ fontFamily: font, fontSize: 13, fontWeight: 800, color: C.accent, marginTop: "auto" }}>Ver funcionalidade →</span>
                    </Link>
                  )}
                </div>
              );
            })()}
          </div>
        </div>
      )}
    </nav>
  );
}
